import { useMutation, useQueryClient } from "react-query";
import AlarmSetpointsDataService from "../../services/alarm-setpoints-data-service/AlarmSetpointsDataService";
import { IDisabledScheduleDTO } from "../../services/alarm-setpoints-data-service/Models";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { DisabledScheduleMutationContextType } from "./Common";
import { keys } from "./Keys";

export type EnableTagSetpointParameters = {
    groupID: number,
    tagID: number,
    setpointID: number,
} & BaseUseMutationParameters<void, void>;

export function useEnableTagSetpoint({
    groupID,
    tagID,
    setpointID,
    onError,
    onSuccess
}: EnableTagSetpointParameters) {
    const queryClient = useQueryClient();

    return useMutation<void, RestError, void, DisabledScheduleMutationContextType>(
        () => {
            return AlarmSetpointsDataService.enableTagSetPoint(
                groupID,
                tagID,
                setpointID
            );
        },
        {
            onMutate: async () => {

                await Promise.all([
                    queryClient.cancelQueries(keys.disableSchedules()),
                    queryClient.cancelQueries(keys.lists())
                ]);

                const previousSchedule = queryClient.getQueryData<IDisabledScheduleDTO>(
                    keys.disableSchedule(groupID, tagID, setpointID)
                );

                queryClient.removeQueries(keys.disableSchedule(groupID, tagID, setpointID))
                // queryClient.setQueryData<IDisabledScheduleDTO>(
                //     keys.disableSchedule(groupID, tagID, setpointID),
                //     (_old?: IDisabledScheduleDTO) => {
                //         return schedule;
                //     }
                // );

                return {
                    previousSchedule: previousSchedule
                };
            },


            onError: onError,
            onSuccess: onSuccess,
            onSettled: (_data, error, _item, context) => {

                if (error && context?.previousSchedule) {
                    queryClient.setQueryData<IDisabledScheduleDTO>(
                        keys.disableSchedule(groupID, tagID, setpointID),
                        context?.previousSchedule
                    );
                }

                queryClient.invalidateQueries(keys.disableSchedules());
                queryClient.invalidateQueries(keys.lists());
            }
        }
    );
}
